// ================= MOVE ART FIGURE REGISTRY (GENERATED) =================
//
// DO NOT EDIT BY HAND. Regenerate with:  node tools/build-move-art-registry.js
// tests/move-art-test.js rebuilds this in memory and fails if it disagrees with the disk, so an
// asset added, renamed or deleted without regenerating is a failing test rather than a broken
// <img> nobody notices.
//
// 728 figures across 29 fighters, plus _shared for the poses that are the same for
// everyone. Paths are LITERAL because tools/build-dist.js scrapes complete quoted asset paths out of
// js/ to decide what to publish -- a path built by concatenation deploys as a 404. See the header of
// the generator for the whole argument.
//
// Lookup goes through window.MoveArt.figurePath(artKey, pose): a fighter's own figure first, then
// _shared, then null -- and null means the SVG pose renders instead, which is why a missing asset
// degrades to a drawing rather than to a hole.
window.MOVE_ART_FIGURES = {
  _shared: {
    dirty: 'assets/move-art/_shared/dirty.webp',
    trap: 'assets/move-art/_shared/trap.webp'
  },
  angle_thief: {
    clinch: 'assets/move-art/angle_thief/clinch.webp',
    counter: 'assets/move-art/angle_thief/counter.webp',
    elbow: 'assets/move-art/angle_thief/elbow.webp',
    feint: 'assets/move-art/angle_thief/feint.webp',
    footwork: 'assets/move-art/angle_thief/footwork.webp',
    frame: 'assets/move-art/angle_thief/frame.webp',
    guard: 'assets/move-art/angle_thief/guard.webp',
    headbutt: 'assets/move-art/angle_thief/headbutt.webp',
    kick_axe: 'assets/move-art/angle_thief/kick_axe.webp',
    kick_front: 'assets/move-art/angle_thief/kick_front.webp',
    kick_round: 'assets/move-art/angle_thief/kick_round.webp',
    kick_side: 'assets/move-art/angle_thief/kick_side.webp',
    knee: 'assets/move-art/angle_thief/knee.webp',
    pressure: 'assets/move-art/angle_thief/pressure.webp',
    punch_hook: 'assets/move-art/angle_thief/punch_hook.webp',
    punch_straight: 'assets/move-art/angle_thief/punch_straight.webp',
    punch_upper: 'assets/move-art/angle_thief/punch_upper.webp',
    read: 'assets/move-art/angle_thief/read.webp',
    recover: 'assets/move-art/angle_thief/recover.webp',
    rotation: 'assets/move-art/angle_thief/rotation.webp',
    sweep: 'assets/move-art/angle_thief/sweep.webp',
    takedown: 'assets/move-art/angle_thief/takedown.webp',
    throw: 'assets/move-art/angle_thief/throw.webp',
    trip: 'assets/move-art/angle_thief/trip.webp'
  },
  back_alley_infighter: {
    clinch: 'assets/move-art/back_alley_infighter/clinch.webp',
    counter: 'assets/move-art/back_alley_infighter/counter.webp',
    elbow: 'assets/move-art/back_alley_infighter/elbow.webp',
    feint: 'assets/move-art/back_alley_infighter/feint.webp',
    footwork: 'assets/move-art/back_alley_infighter/footwork.webp',
    frame: 'assets/move-art/back_alley_infighter/frame.webp',
    guard: 'assets/move-art/back_alley_infighter/guard.webp',
    headbutt: 'assets/move-art/back_alley_infighter/headbutt.webp',
    kick_axe: 'assets/move-art/back_alley_infighter/kick_axe.webp',
    kick_front: 'assets/move-art/back_alley_infighter/kick_front.webp',
    kick_round: 'assets/move-art/back_alley_infighter/kick_round.webp',
    kick_side: 'assets/move-art/back_alley_infighter/kick_side.webp',
    knee: 'assets/move-art/back_alley_infighter/knee.webp',
    pressure: 'assets/move-art/back_alley_infighter/pressure.webp',
    punch_hook: 'assets/move-art/back_alley_infighter/punch_hook.webp',
    punch_straight: 'assets/move-art/back_alley_infighter/punch_straight.webp',
    punch_upper: 'assets/move-art/back_alley_infighter/punch_upper.webp',
    read: 'assets/move-art/back_alley_infighter/read.webp',
    recover: 'assets/move-art/back_alley_infighter/recover.webp',
    rotation: 'assets/move-art/back_alley_infighter/rotation.webp',
    sweep: 'assets/move-art/back_alley_infighter/sweep.webp',
    takedown: 'assets/move-art/back_alley_infighter/takedown.webp',
    throw: 'assets/move-art/back_alley_infighter/throw.webp',
    trip: 'assets/move-art/back_alley_infighter/trip.webp'
  },
  cad_bell_ringer_strongman: {
    clinch: 'assets/move-art/cad_bell_ringer_strongman/clinch.webp',
    counter: 'assets/move-art/cad_bell_ringer_strongman/counter.webp',
    dirty: 'assets/move-art/cad_bell_ringer_strongman/dirty.webp',
    elbow: 'assets/move-art/cad_bell_ringer_strongman/elbow.webp',
    feint: 'assets/move-art/cad_bell_ringer_strongman/feint.webp',
    footwork: 'assets/move-art/cad_bell_ringer_strongman/footwork.webp',
    frame: 'assets/move-art/cad_bell_ringer_strongman/frame.webp',
    guard: 'assets/move-art/cad_bell_ringer_strongman/guard.webp',
    headbutt: 'assets/move-art/cad_bell_ringer_strongman/headbutt.webp',
    kick_axe: 'assets/move-art/cad_bell_ringer_strongman/kick_axe.webp',
    kick_front: 'assets/move-art/cad_bell_ringer_strongman/kick_front.webp',
    kick_round: 'assets/move-art/cad_bell_ringer_strongman/kick_round.webp',
    kick_side: 'assets/move-art/cad_bell_ringer_strongman/kick_side.webp',
    knee: 'assets/move-art/cad_bell_ringer_strongman/knee.webp',
    pressure: 'assets/move-art/cad_bell_ringer_strongman/pressure.webp',
    punch_hook: 'assets/move-art/cad_bell_ringer_strongman/punch_hook.webp',
    punch_straight: 'assets/move-art/cad_bell_ringer_strongman/punch_straight.webp',
    punch_upper: 'assets/move-art/cad_bell_ringer_strongman/punch_upper.webp',
    read: 'assets/move-art/cad_bell_ringer_strongman/read.webp',
    recover: 'assets/move-art/cad_bell_ringer_strongman/recover.webp',
    rotation: 'assets/move-art/cad_bell_ringer_strongman/rotation.webp',
    sweep: 'assets/move-art/cad_bell_ringer_strongman/sweep.webp',
    takedown: 'assets/move-art/cad_bell_ringer_strongman/takedown.webp',
    throw: 'assets/move-art/cad_bell_ringer_strongman/throw.webp',
    trap: 'assets/move-art/cad_bell_ringer_strongman/trap.webp',
    trip: 'assets/move-art/cad_bell_ringer_strongman/trip.webp'
  },
  cad_high_wire_heel: {
    clinch: 'assets/move-art/cad_high_wire_heel/clinch.webp',
    counter: 'assets/move-art/cad_high_wire_heel/counter.webp',
    dirty: 'assets/move-art/cad_high_wire_heel/dirty.webp',
    elbow: 'assets/move-art/cad_high_wire_heel/elbow.webp',
    feint: 'assets/move-art/cad_high_wire_heel/feint.webp',
    footwork: 'assets/move-art/cad_high_wire_heel/footwork.webp',
    frame: 'assets/move-art/cad_high_wire_heel/frame.webp',
    guard: 'assets/move-art/cad_high_wire_heel/guard.webp',
    headbutt: 'assets/move-art/cad_high_wire_heel/headbutt.webp',
    kick_axe: 'assets/move-art/cad_high_wire_heel/kick_axe.webp',
    kick_front: 'assets/move-art/cad_high_wire_heel/kick_front.webp',
    kick_round: 'assets/move-art/cad_high_wire_heel/kick_round.webp',
    kick_side: 'assets/move-art/cad_high_wire_heel/kick_side.webp',
    knee: 'assets/move-art/cad_high_wire_heel/knee.webp',
    pressure: 'assets/move-art/cad_high_wire_heel/pressure.webp',
    punch_hook: 'assets/move-art/cad_high_wire_heel/punch_hook.webp',
    punch_straight: 'assets/move-art/cad_high_wire_heel/punch_straight.webp',
    punch_upper: 'assets/move-art/cad_high_wire_heel/punch_upper.webp',
    read: 'assets/move-art/cad_high_wire_heel/read.webp',
    recover: 'assets/move-art/cad_high_wire_heel/recover.webp',
    rotation: 'assets/move-art/cad_high_wire_heel/rotation.webp',
    sweep: 'assets/move-art/cad_high_wire_heel/sweep.webp',
    takedown: 'assets/move-art/cad_high_wire_heel/takedown.webp',
    throw: 'assets/move-art/cad_high_wire_heel/throw.webp',
    trap: 'assets/move-art/cad_high_wire_heel/trap.webp',
    trip: 'assets/move-art/cad_high_wire_heel/trip.webp'
  },
  cad_mirror_maze_mimic: {
    clinch: 'assets/move-art/cad_mirror_maze_mimic/clinch.webp',
    counter: 'assets/move-art/cad_mirror_maze_mimic/counter.webp',
    dirty: 'assets/move-art/cad_mirror_maze_mimic/dirty.webp',
    elbow: 'assets/move-art/cad_mirror_maze_mimic/elbow.webp',
    feint: 'assets/move-art/cad_mirror_maze_mimic/feint.webp',
    footwork: 'assets/move-art/cad_mirror_maze_mimic/footwork.webp',
    frame: 'assets/move-art/cad_mirror_maze_mimic/frame.webp',
    guard: 'assets/move-art/cad_mirror_maze_mimic/guard.webp',
    headbutt: 'assets/move-art/cad_mirror_maze_mimic/headbutt.webp',
    kick_axe: 'assets/move-art/cad_mirror_maze_mimic/kick_axe.webp',
    kick_front: 'assets/move-art/cad_mirror_maze_mimic/kick_front.webp',
    kick_round: 'assets/move-art/cad_mirror_maze_mimic/kick_round.webp',
    kick_side: 'assets/move-art/cad_mirror_maze_mimic/kick_side.webp',
    knee: 'assets/move-art/cad_mirror_maze_mimic/knee.webp',
    pressure: 'assets/move-art/cad_mirror_maze_mimic/pressure.webp',
    punch_hook: 'assets/move-art/cad_mirror_maze_mimic/punch_hook.webp',
    punch_straight: 'assets/move-art/cad_mirror_maze_mimic/punch_straight.webp',
    punch_upper: 'assets/move-art/cad_mirror_maze_mimic/punch_upper.webp',
    read: 'assets/move-art/cad_mirror_maze_mimic/read.webp',
    recover: 'assets/move-art/cad_mirror_maze_mimic/recover.webp',
    rotation: 'assets/move-art/cad_mirror_maze_mimic/rotation.webp',
    sweep: 'assets/move-art/cad_mirror_maze_mimic/sweep.webp',
    takedown: 'assets/move-art/cad_mirror_maze_mimic/takedown.webp',
    throw: 'assets/move-art/cad_mirror_maze_mimic/throw.webp',
    trap: 'assets/move-art/cad_mirror_maze_mimic/trap.webp',
    trip: 'assets/move-art/cad_mirror_maze_mimic/trip.webp'
  },
  centerline_rewoven: {
    clinch: 'assets/move-art/centerline_rewoven/clinch.webp',
    counter: 'assets/move-art/centerline_rewoven/counter.webp',
    elbow: 'assets/move-art/centerline_rewoven/elbow.webp',
    feint: 'assets/move-art/centerline_rewoven/feint.webp',
    footwork: 'assets/move-art/centerline_rewoven/footwork.webp',
    frame: 'assets/move-art/centerline_rewoven/frame.webp',
    guard: 'assets/move-art/centerline_rewoven/guard.webp',
    headbutt: 'assets/move-art/centerline_rewoven/headbutt.webp',
    kick_axe: 'assets/move-art/centerline_rewoven/kick_axe.webp',
    kick_front: 'assets/move-art/centerline_rewoven/kick_front.webp',
    kick_round: 'assets/move-art/centerline_rewoven/kick_round.webp',
    kick_side: 'assets/move-art/centerline_rewoven/kick_side.webp',
    knee: 'assets/move-art/centerline_rewoven/knee.webp',
    pressure: 'assets/move-art/centerline_rewoven/pressure.webp',
    punch_hook: 'assets/move-art/centerline_rewoven/punch_hook.webp',
    punch_straight: 'assets/move-art/centerline_rewoven/punch_straight.webp',
    punch_upper: 'assets/move-art/centerline_rewoven/punch_upper.webp',
    read: 'assets/move-art/centerline_rewoven/read.webp',
    recover: 'assets/move-art/centerline_rewoven/recover.webp',
    rotation: 'assets/move-art/centerline_rewoven/rotation.webp',
    sweep: 'assets/move-art/centerline_rewoven/sweep.webp',
    takedown: 'assets/move-art/centerline_rewoven/takedown.webp',
    throw: 'assets/move-art/centerline_rewoven/throw.webp',
    trip: 'assets/move-art/centerline_rewoven/trip.webp'
  },
  chain_reaction: {
    clinch: 'assets/move-art/chain_reaction/clinch.webp',
    counter: 'assets/move-art/chain_reaction/counter.webp',
    elbow: 'assets/move-art/chain_reaction/elbow.webp',
    feint: 'assets/move-art/chain_reaction/feint.webp',
    footwork: 'assets/move-art/chain_reaction/footwork.webp',
    frame: 'assets/move-art/chain_reaction/frame.webp',
    guard: 'assets/move-art/chain_reaction/guard.webp',
    headbutt: 'assets/move-art/chain_reaction/headbutt.webp',
    kick_axe: 'assets/move-art/chain_reaction/kick_axe.webp',
    kick_front: 'assets/move-art/chain_reaction/kick_front.webp',
    kick_round: 'assets/move-art/chain_reaction/kick_round.webp',
    kick_side: 'assets/move-art/chain_reaction/kick_side.webp',
    knee: 'assets/move-art/chain_reaction/knee.webp',
    pressure: 'assets/move-art/chain_reaction/pressure.webp',
    punch_hook: 'assets/move-art/chain_reaction/punch_hook.webp',
    punch_straight: 'assets/move-art/chain_reaction/punch_straight.webp',
    punch_upper: 'assets/move-art/chain_reaction/punch_upper.webp',
    read: 'assets/move-art/chain_reaction/read.webp',
    recover: 'assets/move-art/chain_reaction/recover.webp',
    rotation: 'assets/move-art/chain_reaction/rotation.webp',
    sweep: 'assets/move-art/chain_reaction/sweep.webp',
    takedown: 'assets/move-art/chain_reaction/takedown.webp',
    throw: 'assets/move-art/chain_reaction/throw.webp',
    trip: 'assets/move-art/chain_reaction/trip.webp'
  },
  clinch_furnace: {
    clinch: 'assets/move-art/clinch_furnace/clinch.webp',
    counter: 'assets/move-art/clinch_furnace/counter.webp',
    elbow: 'assets/move-art/clinch_furnace/elbow.webp',
    feint: 'assets/move-art/clinch_furnace/feint.webp',
    footwork: 'assets/move-art/clinch_furnace/footwork.webp',
    frame: 'assets/move-art/clinch_furnace/frame.webp',
    guard: 'assets/move-art/clinch_furnace/guard.webp',
    headbutt: 'assets/move-art/clinch_furnace/headbutt.webp',
    kick_axe: 'assets/move-art/clinch_furnace/kick_axe.webp',
    kick_front: 'assets/move-art/clinch_furnace/kick_front.webp',
    kick_round: 'assets/move-art/clinch_furnace/kick_round.webp',
    kick_side: 'assets/move-art/clinch_furnace/kick_side.webp',
    knee: 'assets/move-art/clinch_furnace/knee.webp',
    pressure: 'assets/move-art/clinch_furnace/pressure.webp',
    punch_hook: 'assets/move-art/clinch_furnace/punch_hook.webp',
    punch_straight: 'assets/move-art/clinch_furnace/punch_straight.webp',
    punch_upper: 'assets/move-art/clinch_furnace/punch_upper.webp',
    read: 'assets/move-art/clinch_furnace/read.webp',
    recover: 'assets/move-art/clinch_furnace/recover.webp',
    rotation: 'assets/move-art/clinch_furnace/rotation.webp',
    sweep: 'assets/move-art/clinch_furnace/sweep.webp',
    takedown: 'assets/move-art/clinch_furnace/takedown.webp',
    throw: 'assets/move-art/clinch_furnace/throw.webp',
    trip: 'assets/move-art/clinch_furnace/trip.webp'
  },
  distance_tax: {
    clinch: 'assets/move-art/distance_tax/clinch.webp',
    counter: 'assets/move-art/distance_tax/counter.webp',
    elbow: 'assets/move-art/distance_tax/elbow.webp',
    feint: 'assets/move-art/distance_tax/feint.webp',
    footwork: 'assets/move-art/distance_tax/footwork.webp',
    frame: 'assets/move-art/distance_tax/frame.webp',
    guard: 'assets/move-art/distance_tax/guard.webp',
    headbutt: 'assets/move-art/distance_tax/headbutt.webp',
    kick_axe: 'assets/move-art/distance_tax/kick_axe.webp',
    kick_front: 'assets/move-art/distance_tax/kick_front.webp',
    kick_round: 'assets/move-art/distance_tax/kick_round.webp',
    kick_side: 'assets/move-art/distance_tax/kick_side.webp',
    knee: 'assets/move-art/distance_tax/knee.webp',
    pressure: 'assets/move-art/distance_tax/pressure.webp',
    punch_hook: 'assets/move-art/distance_tax/punch_hook.webp',
    punch_straight: 'assets/move-art/distance_tax/punch_straight.webp',
    punch_upper: 'assets/move-art/distance_tax/punch_upper.webp',
    read: 'assets/move-art/distance_tax/read.webp',
    recover: 'assets/move-art/distance_tax/recover.webp',
    rotation: 'assets/move-art/distance_tax/rotation.webp',
    sweep: 'assets/move-art/distance_tax/sweep.webp',
    takedown: 'assets/move-art/distance_tax/takedown.webp',
    throw: 'assets/move-art/distance_tax/throw.webp',
    trip: 'assets/move-art/distance_tax/trip.webp'
  },
  ghost_step: {
    clinch: 'assets/move-art/ghost_step/clinch.webp',
    counter: 'assets/move-art/ghost_step/counter.webp',
    elbow: 'assets/move-art/ghost_step/elbow.webp',
    feint: 'assets/move-art/ghost_step/feint.webp',
    footwork: 'assets/move-art/ghost_step/footwork.webp',
    frame: 'assets/move-art/ghost_step/frame.webp',
    guard: 'assets/move-art/ghost_step/guard.webp',
    headbutt: 'assets/move-art/ghost_step/headbutt.webp',
    kick_axe: 'assets/move-art/ghost_step/kick_axe.webp',
    kick_front: 'assets/move-art/ghost_step/kick_front.webp',
    kick_round: 'assets/move-art/ghost_step/kick_round.webp',
    kick_side: 'assets/move-art/ghost_step/kick_side.webp',
    knee: 'assets/move-art/ghost_step/knee.webp',
    pressure: 'assets/move-art/ghost_step/pressure.webp',
    punch_hook: 'assets/move-art/ghost_step/punch_hook.webp',
    punch_straight: 'assets/move-art/ghost_step/punch_straight.webp',
    punch_upper: 'assets/move-art/ghost_step/punch_upper.webp',
    read: 'assets/move-art/ghost_step/read.webp',
    recover: 'assets/move-art/ghost_step/recover.webp',
    rotation: 'assets/move-art/ghost_step/rotation.webp',
    sweep: 'assets/move-art/ghost_step/sweep.webp',
    takedown: 'assets/move-art/ghost_step/takedown.webp',
    throw: 'assets/move-art/ghost_step/throw.webp',
    trip: 'assets/move-art/ghost_step/trip.webp'
  },
  grand_ippon: {
    clinch: 'assets/move-art/grand_ippon/clinch.webp',
    counter: 'assets/move-art/grand_ippon/counter.webp',
    elbow: 'assets/move-art/grand_ippon/elbow.webp',
    feint: 'assets/move-art/grand_ippon/feint.webp',
    footwork: 'assets/move-art/grand_ippon/footwork.webp',
    frame: 'assets/move-art/grand_ippon/frame.webp',
    guard: 'assets/move-art/grand_ippon/guard.webp',
    headbutt: 'assets/move-art/grand_ippon/headbutt.webp',
    kick_axe: 'assets/move-art/grand_ippon/kick_axe.webp',
    kick_front: 'assets/move-art/grand_ippon/kick_front.webp',
    kick_round: 'assets/move-art/grand_ippon/kick_round.webp',
    kick_side: 'assets/move-art/grand_ippon/kick_side.webp',
    knee: 'assets/move-art/grand_ippon/knee.webp',
    pressure: 'assets/move-art/grand_ippon/pressure.webp',
    punch_hook: 'assets/move-art/grand_ippon/punch_hook.webp',
    punch_straight: 'assets/move-art/grand_ippon/punch_straight.webp',
    punch_upper: 'assets/move-art/grand_ippon/punch_upper.webp',
    read: 'assets/move-art/grand_ippon/read.webp',
    recover: 'assets/move-art/grand_ippon/recover.webp',
    rotation: 'assets/move-art/grand_ippon/rotation.webp',
    sweep: 'assets/move-art/grand_ippon/sweep.webp',
    takedown: 'assets/move-art/grand_ippon/takedown.webp',
    throw: 'assets/move-art/grand_ippon/throw.webp',
    trip: 'assets/move-art/grand_ippon/trip.webp'
  },
  hh_barn_raising_judoka: {
    clinch: 'assets/move-art/hh_barn_raising_judoka/clinch.webp',
    counter: 'assets/move-art/hh_barn_raising_judoka/counter.webp',
    dirty: 'assets/move-art/hh_barn_raising_judoka/dirty.webp',
    elbow: 'assets/move-art/hh_barn_raising_judoka/elbow.webp',
    feint: 'assets/move-art/hh_barn_raising_judoka/feint.webp',
    footwork: 'assets/move-art/hh_barn_raising_judoka/footwork.webp',
    frame: 'assets/move-art/hh_barn_raising_judoka/frame.webp',
    guard: 'assets/move-art/hh_barn_raising_judoka/guard.webp',
    headbutt: 'assets/move-art/hh_barn_raising_judoka/headbutt.webp',
    kick_axe: 'assets/move-art/hh_barn_raising_judoka/kick_axe.webp',
    kick_front: 'assets/move-art/hh_barn_raising_judoka/kick_front.webp',
    kick_round: 'assets/move-art/hh_barn_raising_judoka/kick_round.webp',
    kick_side: 'assets/move-art/hh_barn_raising_judoka/kick_side.webp',
    knee: 'assets/move-art/hh_barn_raising_judoka/knee.webp',
    pressure: 'assets/move-art/hh_barn_raising_judoka/pressure.webp',
    punch_hook: 'assets/move-art/hh_barn_raising_judoka/punch_hook.webp',
    punch_straight: 'assets/move-art/hh_barn_raising_judoka/punch_straight.webp',
    punch_upper: 'assets/move-art/hh_barn_raising_judoka/punch_upper.webp',
    read: 'assets/move-art/hh_barn_raising_judoka/read.webp',
    recover: 'assets/move-art/hh_barn_raising_judoka/recover.webp',
    rotation: 'assets/move-art/hh_barn_raising_judoka/rotation.webp',
    sweep: 'assets/move-art/hh_barn_raising_judoka/sweep.webp',
    takedown: 'assets/move-art/hh_barn_raising_judoka/takedown.webp',
    throw: 'assets/move-art/hh_barn_raising_judoka/throw.webp',
    trap: 'assets/move-art/hh_barn_raising_judoka/trap.webp',
    trip: 'assets/move-art/hh_barn_raising_judoka/trip.webp'
  },
  hh_corn_maze_stalker: {
    clinch: 'assets/move-art/hh_corn_maze_stalker/clinch.webp',
    counter: 'assets/move-art/hh_corn_maze_stalker/counter.webp',
    dirty: 'assets/move-art/hh_corn_maze_stalker/dirty.webp',
    elbow: 'assets/move-art/hh_corn_maze_stalker/elbow.webp',
    feint: 'assets/move-art/hh_corn_maze_stalker/feint.webp',
    footwork: 'assets/move-art/hh_corn_maze_stalker/footwork.webp',
    frame: 'assets/move-art/hh_corn_maze_stalker/frame.webp',
    guard: 'assets/move-art/hh_corn_maze_stalker/guard.webp',
    headbutt: 'assets/move-art/hh_corn_maze_stalker/headbutt.webp',
    kick_axe: 'assets/move-art/hh_corn_maze_stalker/kick_axe.webp',
    kick_front: 'assets/move-art/hh_corn_maze_stalker/kick_front.webp',
    kick_round: 'assets/move-art/hh_corn_maze_stalker/kick_round.webp',
    kick_side: 'assets/move-art/hh_corn_maze_stalker/kick_side.webp',
    knee: 'assets/move-art/hh_corn_maze_stalker/knee.webp',
    pressure: 'assets/move-art/hh_corn_maze_stalker/pressure.webp',
    punch_hook: 'assets/move-art/hh_corn_maze_stalker/punch_hook.webp',
    punch_straight: 'assets/move-art/hh_corn_maze_stalker/punch_straight.webp',
    punch_upper: 'assets/move-art/hh_corn_maze_stalker/punch_upper.webp',
    read: 'assets/move-art/hh_corn_maze_stalker/read.webp',
    recover: 'assets/move-art/hh_corn_maze_stalker/recover.webp',
    rotation: 'assets/move-art/hh_corn_maze_stalker/rotation.webp',
    sweep: 'assets/move-art/hh_corn_maze_stalker/sweep.webp',
    takedown: 'assets/move-art/hh_corn_maze_stalker/takedown.webp',
    throw: 'assets/move-art/hh_corn_maze_stalker/throw.webp',
    trap: 'assets/move-art/hh_corn_maze_stalker/trap.webp',
    trip: 'assets/move-art/hh_corn_maze_stalker/trip.webp'
  },
  hh_orchard_ironhand: {
    clinch: 'assets/move-art/hh_orchard_ironhand/clinch.webp',
    counter: 'assets/move-art/hh_orchard_ironhand/counter.webp',
    dirty: 'assets/move-art/hh_orchard_ironhand/dirty.webp',
    elbow: 'assets/move-art/hh_orchard_ironhand/elbow.webp',
    feint: 'assets/move-art/hh_orchard_ironhand/feint.webp',
    footwork: 'assets/move-art/hh_orchard_ironhand/footwork.webp',
    frame: 'assets/move-art/hh_orchard_ironhand/frame.webp',
    guard: 'assets/move-art/hh_orchard_ironhand/guard.webp',
    headbutt: 'assets/move-art/hh_orchard_ironhand/headbutt.webp',
    kick_axe: 'assets/move-art/hh_orchard_ironhand/kick_axe.webp',
    kick_front: 'assets/move-art/hh_orchard_ironhand/kick_front.webp',
    kick_round: 'assets/move-art/hh_orchard_ironhand/kick_round.webp',
    kick_side: 'assets/move-art/hh_orchard_ironhand/kick_side.webp',
    knee: 'assets/move-art/hh_orchard_ironhand/knee.webp',
    pressure: 'assets/move-art/hh_orchard_ironhand/pressure.webp',
    punch_hook: 'assets/move-art/hh_orchard_ironhand/punch_hook.webp',
    punch_straight: 'assets/move-art/hh_orchard_ironhand/punch_straight.webp',
    punch_upper: 'assets/move-art/hh_orchard_ironhand/punch_upper.webp',
    read: 'assets/move-art/hh_orchard_ironhand/read.webp',
    recover: 'assets/move-art/hh_orchard_ironhand/recover.webp',
    rotation: 'assets/move-art/hh_orchard_ironhand/rotation.webp',
    sweep: 'assets/move-art/hh_orchard_ironhand/sweep.webp',
    takedown: 'assets/move-art/hh_orchard_ironhand/takedown.webp',
    throw: 'assets/move-art/hh_orchard_ironhand/throw.webp',
    trap: 'assets/move-art/hh_orchard_ironhand/trap.webp',
    trip: 'assets/move-art/hh_orchard_ironhand/trip.webp'
  },
  lowline_algorithm: {
    clinch: 'assets/move-art/lowline_algorithm/clinch.webp',
    counter: 'assets/move-art/lowline_algorithm/counter.webp',
    elbow: 'assets/move-art/lowline_algorithm/elbow.webp',
    feint: 'assets/move-art/lowline_algorithm/feint.webp',
    footwork: 'assets/move-art/lowline_algorithm/footwork.webp',
    frame: 'assets/move-art/lowline_algorithm/frame.webp',
    guard: 'assets/move-art/lowline_algorithm/guard.webp',
    headbutt: 'assets/move-art/lowline_algorithm/headbutt.webp',
    kick_axe: 'assets/move-art/lowline_algorithm/kick_axe.webp',
    kick_front: 'assets/move-art/lowline_algorithm/kick_front.webp',
    kick_round: 'assets/move-art/lowline_algorithm/kick_round.webp',
    kick_side: 'assets/move-art/lowline_algorithm/kick_side.webp',
    knee: 'assets/move-art/lowline_algorithm/knee.webp',
    pressure: 'assets/move-art/lowline_algorithm/pressure.webp',
    punch_hook: 'assets/move-art/lowline_algorithm/punch_hook.webp',
    punch_straight: 'assets/move-art/lowline_algorithm/punch_straight.webp',
    punch_upper: 'assets/move-art/lowline_algorithm/punch_upper.webp',
    read: 'assets/move-art/lowline_algorithm/read.webp',
    recover: 'assets/move-art/lowline_algorithm/recover.webp',
    rotation: 'assets/move-art/lowline_algorithm/rotation.webp',
    sweep: 'assets/move-art/lowline_algorithm/sweep.webp',
    takedown: 'assets/move-art/lowline_algorithm/takedown.webp',
    throw: 'assets/move-art/lowline_algorithm/throw.webp',
    trip: 'assets/move-art/lowline_algorithm/trip.webp'
  },
  mm_last_train_southpaw: {
    clinch: 'assets/move-art/mm_last_train_southpaw/clinch.webp',
    counter: 'assets/move-art/mm_last_train_southpaw/counter.webp',
    dirty: 'assets/move-art/mm_last_train_southpaw/dirty.webp',
    elbow: 'assets/move-art/mm_last_train_southpaw/elbow.webp',
    feint: 'assets/move-art/mm_last_train_southpaw/feint.webp',
    footwork: 'assets/move-art/mm_last_train_southpaw/footwork.webp',
    frame: 'assets/move-art/mm_last_train_southpaw/frame.webp',
    guard: 'assets/move-art/mm_last_train_southpaw/guard.webp',
    headbutt: 'assets/move-art/mm_last_train_southpaw/headbutt.webp',
    kick_axe: 'assets/move-art/mm_last_train_southpaw/kick_axe.webp',
    kick_front: 'assets/move-art/mm_last_train_southpaw/kick_front.webp',
    kick_round: 'assets/move-art/mm_last_train_southpaw/kick_round.webp',
    kick_side: 'assets/move-art/mm_last_train_southpaw/kick_side.webp',
    knee: 'assets/move-art/mm_last_train_southpaw/knee.webp',
    pressure: 'assets/move-art/mm_last_train_southpaw/pressure.webp',
    punch_hook: 'assets/move-art/mm_last_train_southpaw/punch_hook.webp',
    punch_straight: 'assets/move-art/mm_last_train_southpaw/punch_straight.webp',
    punch_upper: 'assets/move-art/mm_last_train_southpaw/punch_upper.webp',
    read: 'assets/move-art/mm_last_train_southpaw/read.webp',
    recover: 'assets/move-art/mm_last_train_southpaw/recover.webp',
    rotation: 'assets/move-art/mm_last_train_southpaw/rotation.webp',
    sweep: 'assets/move-art/mm_last_train_southpaw/sweep.webp',
    takedown: 'assets/move-art/mm_last_train_southpaw/takedown.webp',
    throw: 'assets/move-art/mm_last_train_southpaw/throw.webp',
    trap: 'assets/move-art/mm_last_train_southpaw/trap.webp',
    trip: 'assets/move-art/mm_last_train_southpaw/trip.webp'
  },
  mm_platform_pitbull: {
    clinch: 'assets/move-art/mm_platform_pitbull/clinch.webp',
    counter: 'assets/move-art/mm_platform_pitbull/counter.webp',
    dirty: 'assets/move-art/mm_platform_pitbull/dirty.webp',
    elbow: 'assets/move-art/mm_platform_pitbull/elbow.webp',
    feint: 'assets/move-art/mm_platform_pitbull/feint.webp',
    footwork: 'assets/move-art/mm_platform_pitbull/footwork.webp',
    frame: 'assets/move-art/mm_platform_pitbull/frame.webp',
    guard: 'assets/move-art/mm_platform_pitbull/guard.webp',
    headbutt: 'assets/move-art/mm_platform_pitbull/headbutt.webp',
    kick_axe: 'assets/move-art/mm_platform_pitbull/kick_axe.webp',
    kick_front: 'assets/move-art/mm_platform_pitbull/kick_front.webp',
    kick_round: 'assets/move-art/mm_platform_pitbull/kick_round.webp',
    kick_side: 'assets/move-art/mm_platform_pitbull/kick_side.webp',
    knee: 'assets/move-art/mm_platform_pitbull/knee.webp',
    pressure: 'assets/move-art/mm_platform_pitbull/pressure.webp',
    punch_hook: 'assets/move-art/mm_platform_pitbull/punch_hook.webp',
    punch_straight: 'assets/move-art/mm_platform_pitbull/punch_straight.webp',
    punch_upper: 'assets/move-art/mm_platform_pitbull/punch_upper.webp',
    read: 'assets/move-art/mm_platform_pitbull/read.webp',
    recover: 'assets/move-art/mm_platform_pitbull/recover.webp',
    rotation: 'assets/move-art/mm_platform_pitbull/rotation.webp',
    sweep: 'assets/move-art/mm_platform_pitbull/sweep.webp',
    takedown: 'assets/move-art/mm_platform_pitbull/takedown.webp',
    throw: 'assets/move-art/mm_platform_pitbull/throw.webp',
    trap: 'assets/move-art/mm_platform_pitbull/trap.webp',
    trip: 'assets/move-art/mm_platform_pitbull/trip.webp'
  },
  mm_turnstile_technician: {
    clinch: 'assets/move-art/mm_turnstile_technician/clinch.webp',
    counter: 'assets/move-art/mm_turnstile_technician/counter.webp',
    dirty: 'assets/move-art/mm_turnstile_technician/dirty.webp',
    elbow: 'assets/move-art/mm_turnstile_technician/elbow.webp',
    feint: 'assets/move-art/mm_turnstile_technician/feint.webp',
    footwork: 'assets/move-art/mm_turnstile_technician/footwork.webp',
    frame: 'assets/move-art/mm_turnstile_technician/frame.webp',
    guard: 'assets/move-art/mm_turnstile_technician/guard.webp',
    headbutt: 'assets/move-art/mm_turnstile_technician/headbutt.webp',
    kick_axe: 'assets/move-art/mm_turnstile_technician/kick_axe.webp',
    kick_front: 'assets/move-art/mm_turnstile_technician/kick_front.webp',
    kick_round: 'assets/move-art/mm_turnstile_technician/kick_round.webp',
    kick_side: 'assets/move-art/mm_turnstile_technician/kick_side.webp',
    knee: 'assets/move-art/mm_turnstile_technician/knee.webp',
    pressure: 'assets/move-art/mm_turnstile_technician/pressure.webp',
    punch_hook: 'assets/move-art/mm_turnstile_technician/punch_hook.webp',
    punch_straight: 'assets/move-art/mm_turnstile_technician/punch_straight.webp',
    punch_upper: 'assets/move-art/mm_turnstile_technician/punch_upper.webp',
    read: 'assets/move-art/mm_turnstile_technician/read.webp',
    recover: 'assets/move-art/mm_turnstile_technician/recover.webp',
    rotation: 'assets/move-art/mm_turnstile_technician/rotation.webp',
    sweep: 'assets/move-art/mm_turnstile_technician/sweep.webp',
    takedown: 'assets/move-art/mm_turnstile_technician/takedown.webp',
    throw: 'assets/move-art/mm_turnstile_technician/throw.webp',
    trap: 'assets/move-art/mm_turnstile_technician/trap.webp',
    trip: 'assets/move-art/mm_turnstile_technician/trip.webp'
  },
  opportunists_knot: {
    clinch: 'assets/move-art/opportunists_knot/clinch.webp',
    counter: 'assets/move-art/opportunists_knot/counter.webp',
    elbow: 'assets/move-art/opportunists_knot/elbow.webp',
    feint: 'assets/move-art/opportunists_knot/feint.webp',
    footwork: 'assets/move-art/opportunists_knot/footwork.webp',
    frame: 'assets/move-art/opportunists_knot/frame.webp',
    guard: 'assets/move-art/opportunists_knot/guard.webp',
    headbutt: 'assets/move-art/opportunists_knot/headbutt.webp',
    kick_axe: 'assets/move-art/opportunists_knot/kick_axe.webp',
    kick_front: 'assets/move-art/opportunists_knot/kick_front.webp',
    kick_round: 'assets/move-art/opportunists_knot/kick_round.webp',
    kick_side: 'assets/move-art/opportunists_knot/kick_side.webp',
    knee: 'assets/move-art/opportunists_knot/knee.webp',
    pressure: 'assets/move-art/opportunists_knot/pressure.webp',
    punch_hook: 'assets/move-art/opportunists_knot/punch_hook.webp',
    punch_straight: 'assets/move-art/opportunists_knot/punch_straight.webp',
    punch_upper: 'assets/move-art/opportunists_knot/punch_upper.webp',
    read: 'assets/move-art/opportunists_knot/read.webp',
    recover: 'assets/move-art/opportunists_knot/recover.webp',
    rotation: 'assets/move-art/opportunists_knot/rotation.webp',
    sweep: 'assets/move-art/opportunists_knot/sweep.webp',
    takedown: 'assets/move-art/opportunists_knot/takedown.webp',
    throw: 'assets/move-art/opportunists_knot/throw.webp',
    trip: 'assets/move-art/opportunists_knot/trip.webp'
  },
  outside_reader: {
    clinch: 'assets/move-art/outside_reader/clinch.webp',
    counter: 'assets/move-art/outside_reader/counter.webp',
    elbow: 'assets/move-art/outside_reader/elbow.webp',
    feint: 'assets/move-art/outside_reader/feint.webp',
    footwork: 'assets/move-art/outside_reader/footwork.webp',
    frame: 'assets/move-art/outside_reader/frame.webp',
    guard: 'assets/move-art/outside_reader/guard.webp',
    headbutt: 'assets/move-art/outside_reader/headbutt.webp',
    kick_axe: 'assets/move-art/outside_reader/kick_axe.webp',
    kick_front: 'assets/move-art/outside_reader/kick_front.webp',
    kick_round: 'assets/move-art/outside_reader/kick_round.webp',
    kick_side: 'assets/move-art/outside_reader/kick_side.webp',
    knee: 'assets/move-art/outside_reader/knee.webp',
    pressure: 'assets/move-art/outside_reader/pressure.webp',
    punch_hook: 'assets/move-art/outside_reader/punch_hook.webp',
    punch_straight: 'assets/move-art/outside_reader/punch_straight.webp',
    punch_upper: 'assets/move-art/outside_reader/punch_upper.webp',
    read: 'assets/move-art/outside_reader/read.webp',
    recover: 'assets/move-art/outside_reader/recover.webp',
    rotation: 'assets/move-art/outside_reader/rotation.webp',
    sweep: 'assets/move-art/outside_reader/sweep.webp',
    takedown: 'assets/move-art/outside_reader/takedown.webp',
    throw: 'assets/move-art/outside_reader/throw.webp',
    trip: 'assets/move-art/outside_reader/trip.webp'
  },
  rooted_powerline: {
    clinch: 'assets/move-art/rooted_powerline/clinch.webp',
    counter: 'assets/move-art/rooted_powerline/counter.webp',
    elbow: 'assets/move-art/rooted_powerline/elbow.webp',
    feint: 'assets/move-art/rooted_powerline/feint.webp',
    footwork: 'assets/move-art/rooted_powerline/footwork.webp',
    frame: 'assets/move-art/rooted_powerline/frame.webp',
    guard: 'assets/move-art/rooted_powerline/guard.webp',
    headbutt: 'assets/move-art/rooted_powerline/headbutt.webp',
    kick_axe: 'assets/move-art/rooted_powerline/kick_axe.webp',
    kick_front: 'assets/move-art/rooted_powerline/kick_front.webp',
    kick_round: 'assets/move-art/rooted_powerline/kick_round.webp',
    kick_side: 'assets/move-art/rooted_powerline/kick_side.webp',
    knee: 'assets/move-art/rooted_powerline/knee.webp',
    pressure: 'assets/move-art/rooted_powerline/pressure.webp',
    punch_hook: 'assets/move-art/rooted_powerline/punch_hook.webp',
    punch_straight: 'assets/move-art/rooted_powerline/punch_straight.webp',
    punch_upper: 'assets/move-art/rooted_powerline/punch_upper.webp',
    read: 'assets/move-art/rooted_powerline/read.webp',
    recover: 'assets/move-art/rooted_powerline/recover.webp',
    rotation: 'assets/move-art/rooted_powerline/rotation.webp',
    sweep: 'assets/move-art/rooted_powerline/sweep.webp',
    takedown: 'assets/move-art/rooted_powerline/takedown.webp',
    throw: 'assets/move-art/rooted_powerline/throw.webp',
    trip: 'assets/move-art/rooted_powerline/trip.webp'
  },
  sfs_beach_ball_volley: {
    clinch: 'assets/move-art/sfs_beach_ball_volley/clinch.webp',
    counter: 'assets/move-art/sfs_beach_ball_volley/counter.webp',
    dirty: 'assets/move-art/sfs_beach_ball_volley/dirty.webp',
    elbow: 'assets/move-art/sfs_beach_ball_volley/elbow.webp',
    feint: 'assets/move-art/sfs_beach_ball_volley/feint.webp',
    footwork: 'assets/move-art/sfs_beach_ball_volley/footwork.webp',
    frame: 'assets/move-art/sfs_beach_ball_volley/frame.webp',
    guard: 'assets/move-art/sfs_beach_ball_volley/guard.webp',
    headbutt: 'assets/move-art/sfs_beach_ball_volley/headbutt.webp',
    kick_axe: 'assets/move-art/sfs_beach_ball_volley/kick_axe.webp',
    kick_front: 'assets/move-art/sfs_beach_ball_volley/kick_front.webp',
    kick_round: 'assets/move-art/sfs_beach_ball_volley/kick_round.webp',
    kick_side: 'assets/move-art/sfs_beach_ball_volley/kick_side.webp',
    knee: 'assets/move-art/sfs_beach_ball_volley/knee.webp',
    pressure: 'assets/move-art/sfs_beach_ball_volley/pressure.webp',
    punch_hook: 'assets/move-art/sfs_beach_ball_volley/punch_hook.webp',
    punch_straight: 'assets/move-art/sfs_beach_ball_volley/punch_straight.webp',
    punch_upper: 'assets/move-art/sfs_beach_ball_volley/punch_upper.webp',
    read: 'assets/move-art/sfs_beach_ball_volley/read.webp',
    recover: 'assets/move-art/sfs_beach_ball_volley/recover.webp',
    rotation: 'assets/move-art/sfs_beach_ball_volley/rotation.webp',
    sweep: 'assets/move-art/sfs_beach_ball_volley/sweep.webp',
    takedown: 'assets/move-art/sfs_beach_ball_volley/takedown.webp',
    throw: 'assets/move-art/sfs_beach_ball_volley/throw.webp',
    trap: 'assets/move-art/sfs_beach_ball_volley/trap.webp',
    trip: 'assets/move-art/sfs_beach_ball_volley/trip.webp'
  },
  sfs_beach_bum_battle_bro: {
    clinch: 'assets/move-art/sfs_beach_bum_battle_bro/clinch.webp',
    counter: 'assets/move-art/sfs_beach_bum_battle_bro/counter.webp',
    dirty: 'assets/move-art/sfs_beach_bum_battle_bro/dirty.webp',
    elbow: 'assets/move-art/sfs_beach_bum_battle_bro/elbow.webp',
    feint: 'assets/move-art/sfs_beach_bum_battle_bro/feint.webp',
    footwork: 'assets/move-art/sfs_beach_bum_battle_bro/footwork.webp',
    frame: 'assets/move-art/sfs_beach_bum_battle_bro/frame.webp',
    guard: 'assets/move-art/sfs_beach_bum_battle_bro/guard.webp',
    headbutt: 'assets/move-art/sfs_beach_bum_battle_bro/headbutt.webp',
    kick_axe: 'assets/move-art/sfs_beach_bum_battle_bro/kick_axe.webp',
    kick_front: 'assets/move-art/sfs_beach_bum_battle_bro/kick_front.webp',
    kick_round: 'assets/move-art/sfs_beach_bum_battle_bro/kick_round.webp',
    kick_side: 'assets/move-art/sfs_beach_bum_battle_bro/kick_side.webp',
    knee: 'assets/move-art/sfs_beach_bum_battle_bro/knee.webp',
    pressure: 'assets/move-art/sfs_beach_bum_battle_bro/pressure.webp',
    punch_hook: 'assets/move-art/sfs_beach_bum_battle_bro/punch_hook.webp',
    punch_straight: 'assets/move-art/sfs_beach_bum_battle_bro/punch_straight.webp',
    punch_upper: 'assets/move-art/sfs_beach_bum_battle_bro/punch_upper.webp',
    read: 'assets/move-art/sfs_beach_bum_battle_bro/read.webp',
    recover: 'assets/move-art/sfs_beach_bum_battle_bro/recover.webp',
    rotation: 'assets/move-art/sfs_beach_bum_battle_bro/rotation.webp',
    sweep: 'assets/move-art/sfs_beach_bum_battle_bro/sweep.webp',
    takedown: 'assets/move-art/sfs_beach_bum_battle_bro/takedown.webp',
    throw: 'assets/move-art/sfs_beach_bum_battle_bro/throw.webp',
    trap: 'assets/move-art/sfs_beach_bum_battle_bro/trap.webp',
    trip: 'assets/move-art/sfs_beach_bum_battle_bro/trip.webp'
  },
  sfs_metal_detector_patrol: {
    clinch: 'assets/move-art/sfs_metal_detector_patrol/clinch.webp',
    counter: 'assets/move-art/sfs_metal_detector_patrol/counter.webp',
    dirty: 'assets/move-art/sfs_metal_detector_patrol/dirty.webp',
    elbow: 'assets/move-art/sfs_metal_detector_patrol/elbow.webp',
    feint: 'assets/move-art/sfs_metal_detector_patrol/feint.webp',
    footwork: 'assets/move-art/sfs_metal_detector_patrol/footwork.webp',
    frame: 'assets/move-art/sfs_metal_detector_patrol/frame.webp',
    guard: 'assets/move-art/sfs_metal_detector_patrol/guard.webp',
    headbutt: 'assets/move-art/sfs_metal_detector_patrol/headbutt.webp',
    kick_axe: 'assets/move-art/sfs_metal_detector_patrol/kick_axe.webp',
    kick_front: 'assets/move-art/sfs_metal_detector_patrol/kick_front.webp',
    kick_round: 'assets/move-art/sfs_metal_detector_patrol/kick_round.webp',
    kick_side: 'assets/move-art/sfs_metal_detector_patrol/kick_side.webp',
    knee: 'assets/move-art/sfs_metal_detector_patrol/knee.webp',
    pressure: 'assets/move-art/sfs_metal_detector_patrol/pressure.webp',
    punch_hook: 'assets/move-art/sfs_metal_detector_patrol/punch_hook.webp',
    punch_straight: 'assets/move-art/sfs_metal_detector_patrol/punch_straight.webp',
    punch_upper: 'assets/move-art/sfs_metal_detector_patrol/punch_upper.webp',
    read: 'assets/move-art/sfs_metal_detector_patrol/read.webp',
    recover: 'assets/move-art/sfs_metal_detector_patrol/recover.webp',
    rotation: 'assets/move-art/sfs_metal_detector_patrol/rotation.webp',
    sweep: 'assets/move-art/sfs_metal_detector_patrol/sweep.webp',
    takedown: 'assets/move-art/sfs_metal_detector_patrol/takedown.webp',
    throw: 'assets/move-art/sfs_metal_detector_patrol/throw.webp',
    trap: 'assets/move-art/sfs_metal_detector_patrol/trap.webp',
    trip: 'assets/move-art/sfs_metal_detector_patrol/trip.webp'
  },
  shovel_trap: {
    clinch: 'assets/move-art/shovel_trap/clinch.webp',
    counter: 'assets/move-art/shovel_trap/counter.webp',
    elbow: 'assets/move-art/shovel_trap/elbow.webp',
    feint: 'assets/move-art/shovel_trap/feint.webp',
    footwork: 'assets/move-art/shovel_trap/footwork.webp',
    frame: 'assets/move-art/shovel_trap/frame.webp',
    guard: 'assets/move-art/shovel_trap/guard.webp',
    headbutt: 'assets/move-art/shovel_trap/headbutt.webp',
    kick_axe: 'assets/move-art/shovel_trap/kick_axe.webp',
    kick_front: 'assets/move-art/shovel_trap/kick_front.webp',
    kick_round: 'assets/move-art/shovel_trap/kick_round.webp',
    kick_side: 'assets/move-art/shovel_trap/kick_side.webp',
    knee: 'assets/move-art/shovel_trap/knee.webp',
    pressure: 'assets/move-art/shovel_trap/pressure.webp',
    punch_hook: 'assets/move-art/shovel_trap/punch_hook.webp',
    punch_straight: 'assets/move-art/shovel_trap/punch_straight.webp',
    punch_upper: 'assets/move-art/shovel_trap/punch_upper.webp',
    read: 'assets/move-art/shovel_trap/read.webp',
    recover: 'assets/move-art/shovel_trap/recover.webp',
    rotation: 'assets/move-art/shovel_trap/rotation.webp',
    sweep: 'assets/move-art/shovel_trap/sweep.webp',
    takedown: 'assets/move-art/shovel_trap/takedown.webp',
    throw: 'assets/move-art/shovel_trap/throw.webp',
    trip: 'assets/move-art/shovel_trap/trip.webp'
  },
  skyfire_exhibition: {
    clinch: 'assets/move-art/skyfire_exhibition/clinch.webp',
    counter: 'assets/move-art/skyfire_exhibition/counter.webp',
    elbow: 'assets/move-art/skyfire_exhibition/elbow.webp',
    feint: 'assets/move-art/skyfire_exhibition/feint.webp',
    footwork: 'assets/move-art/skyfire_exhibition/footwork.webp',
    frame: 'assets/move-art/skyfire_exhibition/frame.webp',
    guard: 'assets/move-art/skyfire_exhibition/guard.webp',
    headbutt: 'assets/move-art/skyfire_exhibition/headbutt.webp',
    kick_axe: 'assets/move-art/skyfire_exhibition/kick_axe.webp',
    kick_front: 'assets/move-art/skyfire_exhibition/kick_front.webp',
    kick_round: 'assets/move-art/skyfire_exhibition/kick_round.webp',
    kick_side: 'assets/move-art/skyfire_exhibition/kick_side.webp',
    knee: 'assets/move-art/skyfire_exhibition/knee.webp',
    pressure: 'assets/move-art/skyfire_exhibition/pressure.webp',
    punch_hook: 'assets/move-art/skyfire_exhibition/punch_hook.webp',
    punch_straight: 'assets/move-art/skyfire_exhibition/punch_straight.webp',
    punch_upper: 'assets/move-art/skyfire_exhibition/punch_upper.webp',
    read: 'assets/move-art/skyfire_exhibition/read.webp',
    recover: 'assets/move-art/skyfire_exhibition/recover.webp',
    rotation: 'assets/move-art/skyfire_exhibition/rotation.webp',
    sweep: 'assets/move-art/skyfire_exhibition/sweep.webp',
    takedown: 'assets/move-art/skyfire_exhibition/takedown.webp',
    throw: 'assets/move-art/skyfire_exhibition/throw.webp',
    trip: 'assets/move-art/skyfire_exhibition/trip.webp'
  },
  wfc_apres_ski_slugger: {
    clinch: 'assets/move-art/wfc_apres_ski_slugger/clinch.webp',
    counter: 'assets/move-art/wfc_apres_ski_slugger/counter.webp',
    dirty: 'assets/move-art/wfc_apres_ski_slugger/dirty.webp',
    elbow: 'assets/move-art/wfc_apres_ski_slugger/elbow.webp',
    feint: 'assets/move-art/wfc_apres_ski_slugger/feint.webp',
    footwork: 'assets/move-art/wfc_apres_ski_slugger/footwork.webp',
    frame: 'assets/move-art/wfc_apres_ski_slugger/frame.webp',
    guard: 'assets/move-art/wfc_apres_ski_slugger/guard.webp',
    headbutt: 'assets/move-art/wfc_apres_ski_slugger/headbutt.webp',
    kick_axe: 'assets/move-art/wfc_apres_ski_slugger/kick_axe.webp',
    kick_front: 'assets/move-art/wfc_apres_ski_slugger/kick_front.webp',
    kick_round: 'assets/move-art/wfc_apres_ski_slugger/kick_round.webp',
    kick_side: 'assets/move-art/wfc_apres_ski_slugger/kick_side.webp',
    knee: 'assets/move-art/wfc_apres_ski_slugger/knee.webp',
    pressure: 'assets/move-art/wfc_apres_ski_slugger/pressure.webp',
    punch_hook: 'assets/move-art/wfc_apres_ski_slugger/punch_hook.webp',
    punch_straight: 'assets/move-art/wfc_apres_ski_slugger/punch_straight.webp',
    punch_upper: 'assets/move-art/wfc_apres_ski_slugger/punch_upper.webp',
    read: 'assets/move-art/wfc_apres_ski_slugger/read.webp',
    recover: 'assets/move-art/wfc_apres_ski_slugger/recover.webp',
    rotation: 'assets/move-art/wfc_apres_ski_slugger/rotation.webp',
    sweep: 'assets/move-art/wfc_apres_ski_slugger/sweep.webp',
    takedown: 'assets/move-art/wfc_apres_ski_slugger/takedown.webp',
    throw: 'assets/move-art/wfc_apres_ski_slugger/throw.webp',
    trap: 'assets/move-art/wfc_apres_ski_slugger/trap.webp',
    trip: 'assets/move-art/wfc_apres_ski_slugger/trip.webp'
  },
  wfc_black_ice_breaker: {
    clinch: 'assets/move-art/wfc_black_ice_breaker/clinch.webp',
    counter: 'assets/move-art/wfc_black_ice_breaker/counter.webp',
    dirty: 'assets/move-art/wfc_black_ice_breaker/dirty.webp',
    elbow: 'assets/move-art/wfc_black_ice_breaker/elbow.webp',
    feint: 'assets/move-art/wfc_black_ice_breaker/feint.webp',
    footwork: 'assets/move-art/wfc_black_ice_breaker/footwork.webp',
    frame: 'assets/move-art/wfc_black_ice_breaker/frame.webp',
    guard: 'assets/move-art/wfc_black_ice_breaker/guard.webp',
    headbutt: 'assets/move-art/wfc_black_ice_breaker/headbutt.webp',
    kick_axe: 'assets/move-art/wfc_black_ice_breaker/kick_axe.webp',
    kick_front: 'assets/move-art/wfc_black_ice_breaker/kick_front.webp',
    kick_round: 'assets/move-art/wfc_black_ice_breaker/kick_round.webp',
    kick_side: 'assets/move-art/wfc_black_ice_breaker/kick_side.webp',
    knee: 'assets/move-art/wfc_black_ice_breaker/knee.webp',
    pressure: 'assets/move-art/wfc_black_ice_breaker/pressure.webp',
    punch_hook: 'assets/move-art/wfc_black_ice_breaker/punch_hook.webp',
    punch_straight: 'assets/move-art/wfc_black_ice_breaker/punch_straight.webp',
    punch_upper: 'assets/move-art/wfc_black_ice_breaker/punch_upper.webp',
    read: 'assets/move-art/wfc_black_ice_breaker/read.webp',
    recover: 'assets/move-art/wfc_black_ice_breaker/recover.webp',
    rotation: 'assets/move-art/wfc_black_ice_breaker/rotation.webp',
    sweep: 'assets/move-art/wfc_black_ice_breaker/sweep.webp',
    takedown: 'assets/move-art/wfc_black_ice_breaker/takedown.webp',
    throw: 'assets/move-art/wfc_black_ice_breaker/throw.webp',
    trap: 'assets/move-art/wfc_black_ice_breaker/trap.webp',
    trip: 'assets/move-art/wfc_black_ice_breaker/trip.webp'
  },
  wfc_snowplow_clincher: {
    clinch: 'assets/move-art/wfc_snowplow_clincher/clinch.webp',
    counter: 'assets/move-art/wfc_snowplow_clincher/counter.webp',
    dirty: 'assets/move-art/wfc_snowplow_clincher/dirty.webp',
    elbow: 'assets/move-art/wfc_snowplow_clincher/elbow.webp',
    feint: 'assets/move-art/wfc_snowplow_clincher/feint.webp',
    footwork: 'assets/move-art/wfc_snowplow_clincher/footwork.webp',
    frame: 'assets/move-art/wfc_snowplow_clincher/frame.webp',
    guard: 'assets/move-art/wfc_snowplow_clincher/guard.webp',
    headbutt: 'assets/move-art/wfc_snowplow_clincher/headbutt.webp',
    kick_axe: 'assets/move-art/wfc_snowplow_clincher/kick_axe.webp',
    kick_front: 'assets/move-art/wfc_snowplow_clincher/kick_front.webp',
    kick_round: 'assets/move-art/wfc_snowplow_clincher/kick_round.webp',
    kick_side: 'assets/move-art/wfc_snowplow_clincher/kick_side.webp',
    knee: 'assets/move-art/wfc_snowplow_clincher/knee.webp',
    pressure: 'assets/move-art/wfc_snowplow_clincher/pressure.webp',
    punch_hook: 'assets/move-art/wfc_snowplow_clincher/punch_hook.webp',
    punch_straight: 'assets/move-art/wfc_snowplow_clincher/punch_straight.webp',
    punch_upper: 'assets/move-art/wfc_snowplow_clincher/punch_upper.webp',
    read: 'assets/move-art/wfc_snowplow_clincher/read.webp',
    recover: 'assets/move-art/wfc_snowplow_clincher/recover.webp',
    rotation: 'assets/move-art/wfc_snowplow_clincher/rotation.webp',
    sweep: 'assets/move-art/wfc_snowplow_clincher/sweep.webp',
    takedown: 'assets/move-art/wfc_snowplow_clincher/takedown.webp',
    throw: 'assets/move-art/wfc_snowplow_clincher/throw.webp',
    trap: 'assets/move-art/wfc_snowplow_clincher/trap.webp',
    trip: 'assets/move-art/wfc_snowplow_clincher/trip.webp'
  }
};

// ---- placement, measured from the ink rather than authored ----------------------------------------
//
// Per pose, the union of every fighter's ink box:
//   w, h             -- the measured ink box, as a fraction of the 512px canvas. Published so the
//                      derivation below is checkable rather than trusted.
//   fit  1/max(w,h)  -- box size multiplier, so the ink's larger dimension is always the base size.
//                      Without it a compact pose renders 1.37x smaller than a sprawling one at the
//                      same CSS size, because object-fit fits the CANVAS and the ink does not fill it.
//   rx   1 - maxX    -- empty canvas to the right of the ink, as a fraction of the box. The anchor
//                      that keeps a roundhouse's foot and a jab's fist inside the frame.
//   by   1 - maxY    -- empty canvas below the ink, so every pose stands on the panel floor rather
//                      than on wherever its own canvas happened to end.
window.MOVE_ART_GEOMETRY = {
  clinch: { w: 0.891, h: 0.857, fit: 1.123, rx: 0.057, by: 0.084 },
  counter: { w: 0.869, h: 0.857, fit: 1.151, rx: 0.092, by: 0.084 },
  dirty: { w: 0.652, h: 0.584, fit: 1.533, rx: 0.176, by: 0.209 },
  elbow: { w: 0.855, h: 0.857, fit: 1.166, rx: 0.105, by: 0.084 },
  feint: { w: 0.92, h: 0.857, fit: 1.087, rx: 0.041, by: 0.084 },
  footwork: { w: 0.732, h: 0.857, fit: 1.166, rx: 0.135, by: 0.084 },
  frame: { w: 0.896, h: 0.857, fit: 1.115, rx: 0.064, by: 0.084 },
  guard: { w: 0.668, h: 0.857, fit: 1.166, rx: 0.203, by: 0.084 },
  headbutt: { w: 0.918, h: 0.857, fit: 1.089, rx: 0.041, by: 0.084 },
  kick_axe: { w: 0.777, h: 0.857, fit: 1.166, rx: 0.113, by: 0.084 },
  kick_front: { w: 0.918, h: 0.857, fit: 1.089, rx: 0.041, by: 0.084 },
  kick_round: { w: 0.916, h: 0.857, fit: 1.092, rx: 0.043, by: 0.084 },
  kick_side: { w: 0.92, h: 0.857, fit: 1.087, rx: 0.041, by: 0.084 },
  knee: { w: 0.719, h: 0.857, fit: 1.166, rx: 0.242, by: 0.084 },
  pressure: { w: 0.873, h: 0.857, fit: 1.145, rx: 0.07, by: 0.084 },
  punch_hook: { w: 0.893, h: 0.857, fit: 1.12, rx: 0.068, by: 0.084 },
  punch_straight: { w: 0.92, h: 0.857, fit: 1.087, rx: 0.041, by: 0.084 },
  punch_upper: { w: 0.627, h: 0.857, fit: 1.166, rx: 0.188, by: 0.084 },
  read: { w: 0.662, h: 0.857, fit: 1.166, rx: 0.17, by: 0.084 },
  recover: { w: 0.92, h: 0.857, fit: 1.087, rx: 0.041, by: 0.084 },
  rotation: { w: 0.908, h: 0.857, fit: 1.101, rx: 0.053, by: 0.084 },
  sweep: { w: 0.92, h: 0.855, fit: 1.087, rx: 0.041, by: 0.084 },
  takedown: { w: 0.92, h: 0.619, fit: 1.087, rx: 0.041, by: 0.084 },
  throw: { w: 0.92, h: 0.857, fit: 1.087, rx: 0.041, by: 0.084 },
  trap: { w: 0.779, h: 0.584, fit: 1.283, rx: 0.111, by: 0.209 },
  trip: { w: 0.92, h: 0.857, fit: 1.087, rx: 0.041, by: 0.084 }
};
